
import { Component, Vue } from 'vue-property-decorator';
import RoleRepository from '@/services/Roles';
import UsersRepo from '@/services/Users';
import { RoleInterface } from '@/services/Roles/Interfaces';
import { WPXFormValue } from '@/components/templates/WPXForm';
import { CreateUserForm } from '@/services/Users/forms/CreateUserForm';
import { DepartmentInterface } from '@/services/Departments/Interfaces';
import DepartmentRepository from '@/services/Departments';
import {
  CreateProfileInterface,
  ProfileRepositoryInterface,
} from '@/services/Users-profile/interfaces';
import PageHeader from '@/components/layout/PageHeader.vue';

@Component({
  inject: [
    'userRepository',
    'rolesRepository',
    'departmentRepository',
    'profileRepository',
  ],
  components: {
    PageHeader,
  },
})
export default class CreateUser extends Vue {
  private readonly userRepository!: UsersRepo;
  private readonly profileRepository!: ProfileRepositoryInterface;
  private readonly rolesRepository!: RoleRepository;
  private readonly departmentRepository!: DepartmentRepository;

  private loading: boolean = true;
  private birthDateMenu: string = '';
  private firstDayMenu: string = '';
  private roles: RoleInterface[] = [];
  private departments: DepartmentInterface[] = [];

  private form: WPXFormValue<CreateUserForm> = new WPXFormValue(CreateUserForm);

  private async created(): Promise<void> {
    try {
      const departments = await this.departmentRepository.getAllDepartments();

      departments.map((department: DepartmentInterface) => {
        this.departments.push(department);
      });
    } catch (e) {
      this.$errorDialog.show(e.response.data.message);
    }

    this.loading = false;
  }

  private async updateRoleField(): Promise<void> {
    const selectedDepartment = this.form.data.department;
    const roles = await this.rolesRepository.getAllByDepartment(selectedDepartment);
    this.roles = [];

    roles.map((role: RoleInterface) => {
      if (role.department) {
        this.roles.push({
          id: role.id,
          name: role.name,
          scopes: [],
          permissions: [],
          department: role.department,
        });
      }
    });

    const roleIds = Object.keys(roles);
    if (roleIds) {
      this.form.data.role = String(roleIds.shift());
    }
  }

  private async createUser(): Promise<void> {
    try {
      const createdUser = await this.userRepository.createUser({
        username: this.form.data.username,
        email: this.form.data.email,
        password: this.form.data.password,
        passwordConf: this.form.data.passwordConf,
        role: this.form.data.role,
        department: this.form.data.department,
        details: {
          firstName: this.form.data.firstName,
          lastName: this.form.data.lastName,
          birthDate: new Date(this.form.data.birthDate),
          firstDay: new Date(this.form.data.firstDay),
        },
      });

      this.$successDialog.show(`User '${this.form.data.username}' has been created`);
    } catch (err) {
      this.$errorDialog.show(err.response.data.message);
    }
  }
}
